import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

// ion-footer writes role="contentinfo" on every render and does not inherit the
// attribute from the template, so it has to be stripped and kept stripped.
@Directive({
    selector: 'ion-footer[appNoContentinfo]',
    standalone: true,
})
export class NoContentinfoDirective implements OnInit, OnDestroy {

  private observer?: MutationObserver;

  constructor(private el: ElementRef<HTMLElement>) { }

  ngOnInit() {
    this.strip();
    this.observer = new MutationObserver(() => this.strip());
    this.observer.observe(this.el.nativeElement, { attributeFilter: ['role'] });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private strip() {
    if (this.el.nativeElement.hasAttribute('role')) {
      this.el.nativeElement.removeAttribute('role');
    }
  }
}
